import * as d3 from 'd3';
import {poissonDiscSampler} from './sampler'
import {isMobile} from './utils'

const screen_w = document.documentElement.clientWidth
const screen_h = window.innerHeight

//CAPTIONS FOR SCROLLER
const holder = document.getElementById('captions-holder')
const captions = holder.querySelectorAll('div')
let graphic_top = document.getElementById("s-graphic").getBoundingClientRect().top

// SCROLLER 
let prev_step = -1
let down_scroll = true
let step;
let pos;

// is this scrolling down 
let last_st = window.pageYOffset || document.documentElement.scrollTop;

function up_downer() {
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if (st > last_st){
        down_scroll = true
     } else {
        down_scroll = false
     }
     last_st = st
  }

//figure set up
let force_svg = d3.select('#s-svg')
      .attr('width', screen_w)
      .attr('height', screen_h)

// some var for responsive shapes
let px = 150
let radius = Math.sqrt(screen_w * screen_h/600)
let figScale = (radius/(px*0.35))
let padding= radius*1.2


//Blue noise POSITION samples  (victim count = 294)
const samples = [...poissonDiscSampler(0, 0, screen_w, screen_h, radius)]
          .filter(([x,y])=> x < screen_w-padding && y < screen_h)
          .map(([x,y])=>({x,y}))
          .sort((a,b)=>a.y-b.y)

//DATA
const victims = d3.csv("static/data/women.csv")


const promise = new Promise(function(resolve,reject){
  resolve(samples)
 })


promise.then(function(samples){
  victims.then(function(data){

    const mapped = data.map((d,i)=>Object.assign({},d,samples[i])).sort((a,b)=>a.y-b.y)

   // console.log(samples.length,  mapped)



//initial set up of positions
  let wees = ["b", "e", "h", "i", "k", "l", "m", "n", "p", "q", "r", "s", "u" ]

  let women = force_svg
  // .append('g')
    .selectAll('text') 
    .data(mapped).enter() 
    .append('text')
    .attr('class','weepeople')
      .attr("id", (d, i)=> "wo" +i)// optional
      .text((d,i) => wees[Math.floor(Math.random()*wees.length)])
      .attr('font-size',`${px}px`)
      .attr("data-status",(d)=>d.status)
      .attr("data-name", (d)=> d.last_name)
      .attr('x', (d)=> d.x/figScale)
      .attr('y', (d)=> d.y/figScale+px)
      .attr('transform',`scale(${figScale},${figScale})`)
      .attr('fill','none')
      .attr('stroke','black')
      .attr("stroke-width", "0.5px")

  // filter women by status
  let solved = women.filter((d)=> ((d.status == "familiar_suspect")|(d.status =="random_suspect")|(d.status == "intimate_partner")))
                    .sort((a,b)=>a.y-b.y)
  let open = women.filter((d)=> d.status == "open")
  let known = women.filter((d)=> ((d.status == "familiar_suspect")| (d.status == "intimate_partner")))
  let random = women.filter((d)=> d.status == "random_suspect")
  // filter nodes by status 
  let solvedNodes = mapped.filter((d)=> ((d.status == "random_suspect")|(d.status =="familiar_suspect")|(d.status == "intimate_partner")))
  let knownNodes = mapped.filter((d)=> ((d.status == "familiar_suspect")| (d.status == "intimate_partner")))

  let simulation = d3.forceSimulation()

  let draw_list = [
    backfiller,//0
    backfiller,//1
    unsolved,//2
    arrange, //3
    knewOnly, //4
    jackson, //5
    enriquez,//6
    liu
  ]

  function backfiller(){
    if (down_scroll == false){
      women
      // .data(mapped)
      .transition()
      .duration(50)
      // .attr('x', (d)=> d.x/figScale)
      // .attr('y', (d)=> d.y/figScale+px)
      .style('opacity',1)
      .attr('fill',"#bac5cf")
      .style("stroke-dasharray", "0")


      // d3.select('#wl0')
      //   .style('opacity', 0)
    }
  }

  let dropRight = (arr, n = 1) => n && arr.slice(0, -n) || arr
  let scale = d3.scalePow().exponent(2)
    .range([mapped.length,0])
    .domain([screen_h,0])

  function filler(pos){

    let sum = dropRight(d3.range(300), scale(pos))
    mapped.map((d,i)=>Object.assign(d,samples[i]))

      for (var w of sum){
        women
        .filter((d,i) => i == w)
        .transition('0')
        .attr('x', (d)=> d.x/figScale)
        .attr('y', (d)=> d.y/figScale+px)
        .duration(50)
        .attr('stroke','black')
        .attr('fill',"#bac5cf")
        .style("opacity", 1 )
    }
  }

  function positions(fig){
    fig.sort((a,b)=>a.y-b.y)
      .transition()
      .duration(50)
      .attr('x', (d)=> d.x/figScale)
      .attr('y', (d)=> d.y/figScale +px)
  }

  function unsolved(){
    // d3.select('#wl0')
    //   .style('opacity', 1)

    let x,y;
    x = 1/figScale
    y = 1/figScale+px

    mapped.map((d,i)=>Object.assign(d,samples[i]))
    if (down_scroll == false){
      d3.selectAll('.wl')
        .style('opacity', 0)
      positions(women)
    }

    women
    .transition()
    .delay((d,i)=> 2*i)
    .duration(1)
    .attr('stroke','black')
    .attr('fill',(d)=> (d.status == 'open')?"none" : "#bac5cf") // conditional to the status unsolved should be white
    .style("stroke-dasharray",(d)=> (d.status == 'open')?"3" : "0")
    .style('opacity', 1)
  }


  function abreast(){
    simulation
      .nodes(solvedNodes)
      .alphaTarget(1)
      .restart()
      .force('x', d3.forceX(d => ((d.status == "familiar_suspect")|(d.status == "intimate_partner"))? screen_w*0.25 : screen_w*0.75))
      .force('y', d3.forceY(screen_h*0.6)) 
      .force('collide', d3.forceCollide(radius/1.5))
      .velocityDecay(0.5)
  }

  function stacked(){
    simulation
      .nodes(solvedNodes)
      .alpha(1)
      .restart()
      .force('x', d3.forceX(screen_w*0.5))
      .force('y', d3.forceY(d => ((d.status == "familiar_suspect")|(d.status == "intimate_partner"))? screen_h*0.33 : screen_h*0.8))
      .force('collide', d3.forceCollide(radius/1.3))
      .velocityDecay(0.6) 
  }

  abreast()
  stacked()

  const portrait = screen_w < screen_h



  function arrange(){
    // d3.select('#wl0')
    //   .style('opacity', 0)

    d3.selectAll('.wl')
      .style('opacity', 1)

    if (portrait){ // portrait
      stacked()
    }else{
      abreast()
    }
    for (var i = 0; i < 30; ++i) simulation.tick();

    open
      .transition()
      .duration(5)
      .style('opacity', 0)

    if (down_scroll == false){
      solved
        .transition()
        .attr('x', (d)=> d.x/figScale)
        .attr('y', (d)=> d.y/figScale)
        .attr('fill',"#bac5cf")
        .attr('stroke','black')
      // .attr('stroke', '#737e82')
        .style('opacity',1)
    }else{
      solved
        .sort((a,b)=>a.y-b.y)
        .transition()
        .delay(500)
        .duration(800)
        .attr('x', (d)=> d.x/figScale)
        .attr('y', (d)=> d.y/figScale)
    }
  }

  function knewOnly (){
    //change color
    known
    .sort((a,b)=>a.y-b.y)
    .transition()
    .delay(500)
    .duration(500)
    .attr('fill',(d)=> (d.status == 'intimate_partner')?'#F88555' : "#bac5cf")
    .attr('stroke','black')
    // .attr('stroke','#737e82')

    random.transition().duration(500).style('opacity', 0) // goodbye to random suspects
    knownNodes.map((d,i)=>Object.assign(d,samples[i+50]))

  //Spread out known suspects
    known
      .sort((a,b)=>a.y-b.y)
      .transition('4')
      .delay(1500)
      .duration(500)
      .attr('x', (d)=> d.x/figScale)
      .attr('y', (d)=> d.y/figScale)
      .end()

    d3.selectAll('.wl')
      .transition()
      .style('opacity', 0)
  }

  function jackson(){
      d3.select('#wl1')
      .transition()
      .style('opacity', 0)

      known
        .transition('5')
        .delay(550)
        .attr('fill',(d)=> "#f6662A")
        .attr('fill', (d)=> (d.last_name == "BJackson")?'#f6662A':'rgba(186, 197, 207, 0.8)')
        .attr('stroke', (d)=> (d.last_name == "BJackson")?'black':"#bac5cf")
  }
  function enriquez(){
      known
        .transition('6')
        .delay(550)
        .attr('fill', (d)=> (d.last_name == "Enriquez")?'#f6662A':'rgba(186, 197, 207, 0.8)')
        .attr('stroke', (d)=> (d.last_name == "Enriquez")?'black':"#bac5cf")
        .end()
  }
    function liu(){
      known
        .transition('6')
        .delay(550)
        .attr('fill', (d)=> (d.last_name == "Liu")?'#f6662A':'rgba(186, 197, 207, 0.8)')
        .attr('stroke', (d)=> (d.last_name == "Liu")?'black':"#bac5cf")
        .end()
  }

// scroll to draw 
  function scroller(step) {
        let scroll_dir = down_scroll ? 1 : -1
        let func_list = d3.range(prev_step+scroll_dir, step+scroll_dir, scroll_dir)
        if ((down_scroll == true)&&((step ==0 )|(step == 1))){
          filler(pos)
        }
        func_list.forEach((i)=> draw_list[i]())
     //   console.log(step, down_scroll,func_list)
        prev_step = step
    }

  function in_view(el){

    let element_top = el.getBoundingClientRect().top
  // when captions show up
    if ((element_top < screen_h-50) && (element_top > 0)){
      //console.log(element_top, bottom_point)
      step = parseInt(el.dataset.step)
      pos = element_top
      scroller(step)
    }
    // if(graphic_top > last_st){// when we are on top
    //   prev_step=-1
    //   step = 0

    //   women
    //   .attr('fill','none')
    //   .attr('stroke','black')

    //   d3.selectAll('.wl')
    //   .style('opacity', 0)
    // }
  }



  // $(window).scroll(function(){
  //   $(".heroic").css("opacity", 1 - $(window).scrollTop() / (screen_h));
  //   console.log("fadiiiiings")
  // });

let topper = document.getElementById('epigraph')
//FORCE SCROLLER
    window.addEventListener('scroll', function(){
      //fadeToRead(topper)
      up_downer();
      captions.forEach(function(el){
        in_view(el)
    	})        
    })

  })
})



///////////////////////////////////////////Topper 
function fadeToRead(el){
  let element_top = el.getBoundingClientRect().top
  console.log(element_top)

  if ((element_top < 0)){
      //console.log(element_top, bottom_point)
      $("#fullscreen-grid").css("opacity",1+ element_top/ (screen_h));
      $(".big-build").css("opacity", -(element_top-(screen_h/50))/ (screen_h));
      // $(".heroic").css("position",'sticky')
      // $("#epigraph").css("position",'absolute')
      // $("#epigraph").css("top",0)
    }
}



function randomNum(max) {
    return Math.floor(Math.random() * max);
  } 

  let imgPaths = d3.range(0,56).map(x => `static/img/faces/${x}.jpeg`)
  let divArray = d3.range(0,56)

  const wrapper = document.getElementById('fullscreen-grid')
  const box = document.querySelector('template')
  const head = document.getElementById('h1container')
  const big = screen_w>500
  const size = big? 150: 100


  const rowCount = Math.floor((wrapper.offsetHeight)/size)
  const colCount = Math.floor(wrapper.offsetWidth/size)



function appendImg(row,column){
  let face,clone,div, img;

  face = imgPaths.shift()
  clone = document.importNode(box.content, true)
  div = clone.querySelector('div')
      div.setAttribute("style", `grid-row:${row}; grid-column:${column};`)
      div.setAttribute("id", `pic${divArray.shift()}`)
      div.addEventListener("animationend",()=>{
        div.classList.remove("fadeOut")
         div.classList.add("fadeIn")
      })
  img = div.querySelector('img')
      img.src = face
  wrapper.appendChild(clone)
}


function fader(id, img){
    let divId = `#pic${id}`

        $(`${divId}`).addClass('fadeOut'); 
        setTimeout(() => {
            $(`${divId}`).find('img').attr('src', `${img}`)
        }, 1700); 
}

const base = window.location.href

function changeImg(){
  let picBox, firstFace, face,randomId;

  randomId = randomNum(49-imgPaths.length)
  picBox = document.getElementById(`pic${randomId}`)
  firstFace = picBox.firstChild.src.replace(base,"")
  imgPaths.push(firstFace)

  face = imgPaths.shift()
  fader(randomId, face)
}

function setHeight(callback){
    if (!big){
  //head.setAttribute("style",`height:${Math.ceil(2*screen_h/rowCount)}px;top:${Math.round(2*screen_h/rowCount)}px`)
    head.style.height = `${Math.ceil(2*wrapper.offsetHeight/rowCount)}px`
    head.style.top = `${Math.round(2*wrapper.offsetHeight/rowCount)}px`
  }
  callback()
}

function appendTopper(){
  for (let i=1; i< rowCount+1 ; i++){
    for (let c=1; c< colCount+1 ; c++){
    appendImg(i,c)

    }
  }
}

setHeight(appendTopper)
//appendTopper()
changeImg()

let change = setInterval(changeImg, 4000)
setTimeout(() => {clearInterval(change)}, 180000); 

